export const en = {
  timer: {
    activeTimers: 'Active Timer',
    noActiveTimers: 'No active timers',
    pause: 'Pause',
    resume: 'Resume',
    stop: 'Stop',
    confirmStop: 'Are you sure you want to stop the timer? This will apply an XP penalty.',
    completed: 'Completed',
    cancelled: 'Cancelled',
    remaining: 'Remaining',
    elapsed: 'Elapsed'
  },
  discipline: {
    goals: 'Goals',
    stats: 'Statistics',
    xp: 'XP',
    streak: 'Streak',
    totalXP: 'Total XP',
    todayXP: 'XP Earned Today',
    completedSessions: 'Completed Sessions',
    totalTime: 'Total Time'
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    remove: 'Remove',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    continue: 'Continue',
    confirm: 'Confirm',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    loading: 'Loading...',
    processing: 'Processing...',
    required: 'Required',
    optional: 'Optional'
  },
  identityCircle: {
    title: 'IdentityCircle',
    subtitle: 'Your trusted social layer',
    visible: 'Visible',
    hidden: 'Hidden',
    createContent: 'Create Content',
    tabs: {
      connections: 'Connections',
      projects: 'Projects',
      knowledge: 'Knowledge',
      identity: 'Identity'
    },
    create: {
      title: 'Create Content',
      text: 'Text Note',
      voice: 'Voice Note',
      image: 'Image',
      video: 'Video',
      stats: 'Share Stats'
    },
    shareStats: {
      title: 'Share Your Stats',
      share: 'Share Stats'
    },
    connections: {
      title: 'Trusted Connections',
      add: 'Add via QR',
      since: 'Connected since'
    },
    projects: {
      title: 'Projects',
      create: 'Create Project'
    },
    knowledge: {
      title: 'Knowledge Sharing',
      share: 'Share Knowledge'
    },
    identity: {
      title: 'Identity Management',
      privacy: 'Privacy Mode',
      privacyDesc: 'Control who can see your activity',
      verification: 'Verification Status'
    }
  }
};
